import React, {useEffect, useState} from 'react';
import {Input } from "reactstrap";
import {Grid, Chip, Tooltip, Typography, Modal, Box, Button} from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import plus from '../../../assets/images/icon_plus.png'
import styles from '../../../assets/styles/modules/AddCategory.module.css'
import {deleteCategory, editCategory, enterCategoryAPI, getScrapCategory} from "../../../apis/my_service";

const AddCategory = ({changeSensor, changeCategory}) => {
    const [categoryBtnList, setCategoryBtnList] = useState([]) // 카테고리 목록 조회
    const [activeStatus, setActiveStatus] = useState(false); // 인풋태그 display 제어
    const [inputValue, setInputValue] = useState(""); // 카테고리 등록 인풋값 제어
    const [showTooltip, setShowTooltip] = useState([]) // 카테고리 편집|삭제 툴팁 제어
    const [openModal,setOpenModal]= useState(false) // 카테고리 이름 수정 모달창
    const [categoryName, setCategoryName] = useState('') // 카테고리 이름 수정 인풋값
    const [targetIdx, setTargetIdx] = useState('') // 수정할 카테고리 아이디


    useEffect(()=> {
        getScrapCategory().then(res => {
            setCategoryBtnList(res)
        })
    }, [changeSensor])

    // 카테고리 입력 활성화
    const plusBtnClick = () => {
        if (categoryBtnList.length < 5) {
            setActiveStatus(!activeStatus)
        } else {
            alert('카테고리는 최대 5개까지 생성가능합니다.')
        }
    };

    // 카테고리 추가
    const pressEnterKey = (e) => {
        if (e.keyCode === 13) {
            enterCategoryAPI(inputValue)
                .then(res => {
                    setInputValue('')
                    changeCategory(res)
                })
            plusBtnClick()
        }
        changeCategory(false)
    }

    // 카테고리 이름 수정
    const editName = () => {
        editCategory(targetIdx, categoryName).then(res => {
            changeCategory(res)
            openModalClick()
        })
        changeCategory(false)
    }

    //카테고리 칩 삭제
    const clickDelete = (id) => {
        deleteCategory(id).then(res => {
            changeCategory(res)
            })
        changeCategory(false)
        window.location.reload()
    };

    // 카테고리 이름 수정 모달창 제어
    const openModalClick = (bool) => setOpenModal(bool)

    const style = {
        position: 'absolute',
        top: '20%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
        outline: 0,
    };

    return (
        <Grid container className={styles.btn_container}>
            <div className={styles.inputArea}>
                {activeStatus &&
                    <input type="text" className={styles.categoryInput} placeholder="새로운 카테고리" maxLength='5'
                           value={inputValue}
                           onChange={(e) => {setInputValue(e.target.value);}}
                           onKeyDown={pressEnterKey}
                           autoFocus/>}

                {
                    categoryBtnList.length === 0 ?
                        <Tooltip className={styles.createTooltip} title='새로운 카테고리를 생성해보세요!' placement='right' sx={{zIndex:'150'}}
                                 open={true}
                                 componentsProps={{
                                     tooltip: {sx: {fontSize: "13px", backgroundColor: "#db4a51", padding: '13px', letterSpacing: '-0.65px',}}
                                 }}>
                            <img src={plus} alt='카테고리 생성' className={activeStatus ? `${styles.bt_active}` : `${styles.bt_inactive}`} onClick={plusBtnClick}/>
                        </Tooltip>
                        :
                        <Tooltip className={styles.createTooltip} title='새로운 카테고리를 생성해보세요!' placement='right'
                                 componentsProps={{
                                     tooltip: {sx: {fontSize: "13px", backgroundColor: "#db4a51", padding: '13px', letterSpacing: '-0.65px'}}
                                 }}>
                            <img src={plus} alt='카테고리 생성' className={activeStatus ? `${styles.bt_active}` : `${styles.bt_inactive}`} onClick={plusBtnClick}/>
                        </Tooltip>
                }

            </div>

            {categoryBtnList && categoryBtnList.map((category, idx) => {
                const showlist = new Array(categoryBtnList.length).fill(false)
                return (
                    <div key={idx}>
                        <Chip className={styles.chipBtn}
                              label={category.categoryname}
                              sx={{'& .MuiChip-deleteIcon': {color: '#A9A9A9',},}}
                              deleteIcon={<SettingsIcon/>}
                              onDelete={() => {
                                  showlist[idx] = !showlist[idx]
                                  setTargetIdx(category.categoryid)
                                  setShowTooltip(showlist)
                              }}
                        />
                        <div  className={`${styles.createTooltip} ${styles.categoryTooltip} ${showTooltip[idx] ? 'show' : ''}`}>
                            <span className={styles.edit} onClick={()=>openModalClick(true)}>편집</span>|
                            <Modal open={openModal} onClose={()=>openModalClick(false)}>
                                <Box sx={style}>
                                    <Typography className={styles.modal_title}>카테고리 이름을 입력해주세요.</Typography>
                                    <Input type='text' placeholder='변경할 카테고리 이름' className={styles.category_edit_input} maxLength='5'
                                           onChange={(e) => setCategoryName(e.target.value)}
                                           onKeyUp={(e) => {
                                               if (e.keyCode === 13) {editName(category.categoryid)}
                                           }}
                                           autoFocus={true}/>
                                    <Button className="modal_ok" variant='contained' style={{width:'100%', height:'40px'}} onClick={()=> editName()}>수정하기</Button>
                                </Box>
                            </Modal>
                            <span className={styles.delete} onClick={() => clickDelete(category.categoryid)}>삭제</span>
                        </div>
                    </div>
                )
            })}
        </Grid>
    );
};

export default AddCategory;